export function assertIsError(error) {
    if (!(error instanceof Error)) {
        throw error;
    }
}
//# sourceMappingURL=assert-is-error.js.map